import React, { useState } from 'react'
import { Button, Card, Modal, Popconfirm, Row } from 'antd'
import Heading from '../../../component/common/Heading'
import CRUDComponent from '../../../component/common/CRUD-Component'
import CONSTANTS from '../../../util/constant/CONSTANTS'
import { useParams } from 'react-router-dom'
import useHttp from '../../../hooks/use-http'
import { QRCode } from 'react-qrcode-logo'

const DeviceDetails = () => {
    const [refresh, setRefresh] = useState(false)
    const { id } = useParams();
    const deviceTypeId = id.split('-')
    const api = useHttp()
    const [qrData, setQrData] = useState(null)
    // console.log(qrData)

    // console.log(refresh, 'ref');
    const addDeviceHandler = () => {
        const payload = {
            deviceTypeId: +deviceTypeId[1]
        }

        api.sendRequest(CONSTANTS.API.Device.add, () => {
            setRefresh(prev => !prev)
        }, payload, 'Device Added Successfully!!!')


    }

    const downloadQRCode = async () => {
        const canvas = document.getElementById('myqrcode')?.querySelector('canvas');

        if (canvas) {
            // Wait for the QR code to render
            await new Promise(resolve => setTimeout(resolve, 500)); // Adjust the delay as needed

            const url = canvas.toDataURL();
            const a = document.createElement('a');
            a.download = 'QRCode.png';
            a.href = url;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    };



    return (
        <>

            <div>
                <Popconfirm className='mt-5' title="Sure to Add New Device?" onConfirm={addDeviceHandler}>
                    <Button type="primary">
                        Add New Device
                    </Button>
                    {/* <Button type="primary">{value?.name}</Button> */}
                </Popconfirm>
                <Card className="my-5">
                    <Heading>Device List</Heading>
                    <Row>
                        <CRUDComponent

                            GET={{
                                API: CONSTANTS.API.Device.getAll,
                                extraQuery: {
                                    deviceTypeId: deviceTypeId[1],
                                },
                                DataModifier: (res, API, Setrefresh) => {
                                    // console.log(res, "GET ALL ABCD");
                                    return res?.map(data => {
                                        return {
                                            ...data,
                                            no: `D${data?.id.toString().padStart(7, "0")}`,
                                            simId: data?.simId || '-',
                                            isActive: {
                                                checked: !data?.isActive,
                                                id: data?.id,
                                                onClick: (id, val) => {
                                                    const UpdateAPIEnd = { ...CONSTANTS?.API.Device.update };
                                                    UpdateAPIEnd.endpoint = `${UpdateAPIEnd?.endpoint}${id}`;
                                                    API.sendRequest(
                                                        UpdateAPIEnd,
                                                        () => {
                                                            Setrefresh((prev) => !prev);
                                                        },
                                                        { isActive: val },
                                                        `Device ${val ? "Activate" : "De-Activate"} Successfully`
                                                    );
                                                },

                                            },
                                            qrcode: {
                                                id: data?.id,
                                                onClick: () => {
                                                    setQrData({
                                                        uniqueId: data?.uniqueId,
                                                        simId: data?.simId,
                                                    })
                                                }
                                            }


                                        }
                                    })
                                },
                                column: deviceTypeId[1] === '1' ? CONSTANTS.TABLE.DEVICE_1 : CONSTANTS.TABLE.DEVICE_2,
                            }}
                            UPDATE={{
                                API: CONSTANTS.API.Device.update,
                                message: "Updated Device successfully",
                                modaltitle: "Update Device",
                                modalFields: CONSTANTS.FORM_FIELD.DEVICE_MODAL,
                                payloadModifier: (res) => {
                                    return {
                                        simId: res?.simId?.toString()
                                    }
                                },
                            }}
                            // CREATE={{
                            //   API: CONSTANTS.API.Technology.craete,
                            //   message: "Craeyed Technology successfully",
                            //   modaltitle: "add Technology",
                            //   modalFields: CONSTANTS.FORM_FIELD.TECHNOLOGY_MODAL,
                            //   // payloadModifier: (res) => res,
                            // }}
                            DELETE={{
                                API: CONSTANTS.API.Device.delete,
                                message: "Deleted Successfully",
                            }}
                            isSearch={true}
                            reload={refresh}

                        />
                    </Row>
                </Card>
                <Modal
                    open={qrData !== null}
                    title={<p className="form-modal-head mb25">Generate QR Code</p>}
                    okText="Submit"
                    // width={1000}
                    centered
                    cancelButtonProps={{ style: { display: "none" } }}
                    okButtonProps={{ style: { display: "none" } }}
                    className="form-modal-title"
                    onCancel={() => setQrData(null)}
                    onOk={() => setQrData(null)}
                >
                    <div className='flex flex-col justify-center items-center ' >
                        <div id="myqrcode">
                            <QRCode
                                value={deviceTypeId[1] === '1' ? JSON.stringify({
                                    uniqueId: qrData?.uniqueId?.toString(),
                                }) : JSON.stringify({
                                    uniqueId: qrData?.uniqueId?.toString(),
                                    simId: qrData?.simId?.toString(),
                                })}
                                bgColor="#fff"
                                style={{
                                    marginBottom: 16,
                                }}
                            />
                        </div>
                        <Button type="primary" onClick={downloadQRCode}>
                            Download
                        </Button>

                    </div>
                </Modal>
            </div>

        </>
    )
}

export default DeviceDetails